import script from "./OrderSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderSummary.vue?vue&type=script&setup=true&lang=js"

import "./OrderSummary.vue?vue&type=style&index=0&id=0d52e228&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d52e228"]])

export default __exports__